import { NavigationEndpoint } from './types';
import { IconName } from '@/components/atoms/Icon';

export const NavigationEndpointConfig = {
  [NavigationEndpoint.recordings]: {
    iconName: 'IconMenuRecording' as IconName,
    filledIconName: 'IconMenuRecording' as IconName,
    label: 'Recording'
  },
  [NavigationEndpoint.clips]: {
    iconName: 'IconMenuClips' as IconName,
    filledIconName: 'IconMenuClipsFilled' as IconName,
    label: 'Clips'
  },
  [NavigationEndpoint.social]: {
    iconName: 'IconMenuSocial' as IconName,
    filledIconName: 'IconMenuSocialFilled' as IconName,
    label: 'Social'
  },
  [NavigationEndpoint.blog]: {
    iconName: 'IconArticle' as IconName,
    filledIconName: 'IconArticleFilled' as IconName,
    label: 'Blog'
  },
  [NavigationEndpoint.email]: {
    iconName: 'IconMail' as IconName,
    filledIconName: 'IconMailFilled' as IconName,
    label: 'Email'
  },
  [NavigationEndpoint.takeaways]: {
    iconName: 'IconStar' as IconName,
    filledIconName: 'IconStarFilled' as IconName,
    label: 'Takeaways'
  },
  [NavigationEndpoint.custom]: {
    iconName: 'IconBulb' as IconName,
    filledIconName: 'IconBulbFilled' as IconName,
    label: 'Custom'
  }
};

export const NavigationEndpointOrder = [
  NavigationEndpoint.recordings,
  NavigationEndpoint.clips,
  NavigationEndpoint.social,
  NavigationEndpoint.blog,
  NavigationEndpoint.email,
  NavigationEndpoint.takeaways,
  NavigationEndpoint.custom
];

export const CLIP_POPOVER_ASSUME_INSIDE_CLASS_NAME = 'clip-pop-over-assume-inside';

// Right edge of the SessionDetail left nav sidebar (w-20 sidebar + gap + visual padding).
// Used to clamp fixed-position overlays so they stay clear of the sidebar.
export const SESSION_SIDEBAR_WIDTH_PX = 88;
